import "./App.css";
import MainLayout from "./MainLayout";
function App() {
  return (
    <div className="main ">
      <MainLayout />
    </div>
  );
}

export default App;
